import { useResources } from "../../hooks/useResources";
import ContentHeader from "../contentHeader/ContentHeader";
import SearchInput from "../searchInput/SearchInput";
import ScrollbarArrows from "../table/ScrollbarArrows";

interface SectionQuestionsTableProps {
  questionIds: string[];
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onPreview: (questionId: string) => void;
}

const SectionQuestionsTable = ({
  questionIds,
  searchQuery,
  onSearchChange,
  onPreview,
}: SectionQuestionsTableProps) => {
  const { getResourceValue } = useResources();

  // Filter questions based on search query
  const filteredQuestions = questionIds.filter((questionId) =>
    questionId.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <ContentHeader
        title={getResourceValue("section_questions", "Section Questions")}
        headingLevel={2}
        showActions={false}
        className="content-header--section-title"
      />
      <div className="job-details__questions-section">
        <div className="search-section">
          <SearchInput
            value={searchQuery}
            onChange={onSearchChange}
            placeholder={getResourceValue("search", "Search")}
          />
        </div>
        <ScrollbarArrows
          targetId="section-questions-table-scroll"
          tablesScroll={2}
        />
        <div className="data-table-wrapper" id="section-questions-table-scroll">
          <table className="data-table">
            <thead>
              <tr>
                <th>{getResourceValue("question_id", "Question ID")}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filteredQuestions.length > 0 ? (
                filteredQuestions.map((questionId) => (
                  <tr key={questionId}>
                    <td>
                      <span className="text-strong">{questionId}</span>
                    </td>
                    <td>
                      <div className="table-actions">
                        <button
                          className="btn btn-green"
                          onClick={() => onPreview(questionId)}
                        >
                          <i className="f-icon eye-icon"></i>
                          {getResourceValue("preview", "Preview")}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2}>
                    <div className="no-data">
                      {getResourceValue("no_questions_found", "No questions found")}
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default SectionQuestionsTable;

